var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalWorkFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.613 1.4752C10.613 1.04717 10.9634 0.700195 11.3956 0.700195H20.2652C20.6974 0.700195 21.0478 1.04717 21.0478 1.4752V9.22519C21.0478 9.65322 20.6974 10.0002 20.2652 10.0002H11.3956C10.9634 10.0002 10.613 9.65322 10.613 9.22519V1.4752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.613 1.4752C10.613 1.04717 10.9634 0.700195 11.3956 0.700195H20.2652C20.6974 0.700195 21.0478 1.04717 21.0478 1.4752V9.22519C21.0478 9.65322 20.6974 10.0002 20.2652 10.0002H11.3956C10.9634 10.0002 10.613 9.65322 10.613 9.22519V1.4752Z",
    fill: "#FF7409",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 23.1752C0.699951 22.7472 1.05034 22.4002 1.48256 22.4002H10.3521C10.7843 22.4002 11.1347 22.7472 11.1347 23.1752V30.9252C11.1347 31.3532 10.7843 31.7002 10.3521 31.7002H1.48256C1.05034 31.7002 0.699951 31.3532 0.699951 30.9252V23.1752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 23.1752C0.699951 22.7472 1.05034 22.4002 1.48256 22.4002H10.3521C10.7843 22.4002 11.1347 22.7472 11.1347 23.1752V30.9252C11.1347 31.3532 10.7843 31.7002 10.3521 31.7002H1.48256C1.05034 31.7002 0.699951 31.3532 0.699951 30.9252V23.1752Z",
    fill: "#FF7409",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2652 23.1752C20.2652 22.7472 20.6156 22.4002 21.0478 22.4002H29.9173C30.3496 22.4002 30.7 22.7472 30.7 23.1752V30.9252C30.7 31.3532 30.3496 31.7002 29.9173 31.7002H21.0478C20.6156 31.7002 20.2652 31.3532 20.2652 30.9252V23.1752Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2652 23.1752C20.2652 22.7472 20.6156 22.4002 21.0478 22.4002H29.9173C30.3496 22.4002 30.7 22.7472 30.7 23.1752V30.9252C30.7 31.3532 30.3496 31.7002 29.9173 31.7002H21.0478C20.6156 31.7002 20.2652 31.3532 20.2652 30.9252V23.1752Z",
    fill: "#FF7409",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0043 20.5919V15.8127H15.8956M5.78691 20.5919V15.8127H15.8956M15.8956 15.8127V10.5169M11.3956 10.0002H20.2652C20.6974 10.0002 21.0478 9.65322 21.0478 9.22519V1.4752C21.0478 1.04717 20.6974 0.700195 20.2652 0.700195H11.3956C10.9634 0.700195 10.613 1.04717 10.613 1.4752V9.22519C10.613 9.65322 10.9634 10.0002 11.3956 10.0002ZM1.48256 31.7002H10.3521C10.7843 31.7002 11.1347 31.3532 11.1347 30.9252V23.1752C11.1347 22.7472 10.7843 22.4002 10.3521 22.4002H1.48256C1.05034 22.4002 0.699951 22.7472 0.699951 23.1752V30.9252C0.699951 31.3532 1.05034 31.7002 1.48256 31.7002ZM21.0478 31.7002H29.9173C30.3496 31.7002 30.7 31.3532 30.7 30.9252V23.1752C30.7 22.7472 30.3496 22.4002 29.9173 22.4002H21.0478C20.6156 22.4002 20.2652 22.7472 20.2652 23.1752V30.9252C20.2652 31.3532 20.6156 31.7002 21.0478 31.7002Z",
    stroke: "#FF7409",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalWorkFlowIcon);
export default __webpack_public_path__ + "static/media/TotalWorkFlowIcon.fb67de833e02dbd5ce885f8d34c75d1a.svg";
export { ForwardRef as ReactComponent };